import { ProjectEstimateStatusBase } from './base/project-estimate-status-base';

export class ProjectEstimateStatus extends ProjectEstimateStatusBase { }